/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Save_BodyInputs */

const en_cap_save_body = /** @type {(inputs: Cap_Save_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customer questions, follow-ups, order entry, reports. The system drafts from your own sources and records; your team checks and sends.`)
};

const lv_cap_save_body = /** @type {(inputs: Cap_Save_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klientu jautājumi, atgādinājumi, pasūtījumu ievade, atskaites. Sistēma sagatavo melnrakstu no Jūsu avotiem un ierakstiem, komanda pārbauda un nosūta.`)
};

/**
* | output |
* | --- |
* | "Customer questions, follow-ups, order entry, reports. The system drafts from your own sources and records; your team checks and sends." |
*
* @param {Cap_Save_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_save_body = /** @type {((inputs?: Cap_Save_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Save_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_save_body(inputs)
	return en_cap_save_body(inputs)
});